"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.settings = void 0;

var Button_1 = require("./components/Button");

var Settings =
/** @class */
function () {
  function Settings() {
    var _this = this;

    this._colours = {
      selected: '#27a085',
      correct: '#27a085',
      warning: '#F2A041',
      error: '#F26152',
      border: '#DDDDDD',
      backgroundDisabled: '#F2F2F2',
      background: '#ffffff',
      textDisabled: '#AAAAAA',
      textInput: '#333333',
      textDisplayMessage: '#FFFFFF',
      text: '#000000'
    };
    this._defaultButton = Button_1.Button;

    this.setColours = function (colours) {
      return _this._colours = __assign(__assign({}, _this._colours), colours);
    };

    this.setDefaultButton = function (value) {
      return _this._defaultButton = value;
    };
  }

  Object.defineProperty(Settings.prototype, "colours", {
    get: function get() {
      return this._colours;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(Settings.prototype, "DefaultButton", {
    get: function get() {
      return this._defaultButton;
    },
    enumerable: false,
    configurable: true
  });
  return Settings;
}();

exports.settings = new Settings();